module.exports = __webpack_public_path__ + "img/s00171.76eceb2f.png";